<template>
  <v-layout column>
    <h2 class="primary--text headline font-weight-light">Ingredience</h2>
    <v-layout v-for="(section, index) in sections" :key="index" column>
      <h3 v-if="section.section !== 'Default'" class="title font-weight-light mt-1">{{ section.section }}</h3>
      <v-layout
        v-for="(ingredient, index) in section.ingredients"
        :key="index"
        my-2
      >
        <v-flex xs4 mr-2 class="title accent--text text-xs-right">
          {{ ingredient.amount }}
        </v-flex>
        <v-flex xs8 class="subheading primary--text font-weight-bold">
          {{ ingredient.name }}
        </v-flex>
      </v-layout>
      <v-flex mt-1 v-if="!section.ingredients.length">
        {{ emptyText }}
      </v-flex>
    </v-layout>
    <v-flex mt-1 v-if="!sections.length"> {{ emptyText }} </v-flex>
  </v-layout>
</template>

<script>

export default {
  name: "RecipeIngredients",
  props: {
    sections: {
      type: Array,
      default: () => []
    },
    emptyText: {
      type: String,
      default: "Žádné ingredience nebyly zadány"
    }
  }
};
</script>
